document.addEventListener('DOMContentLoaded', () => {
  // Vetëm për desktop (mouse/trackpad). Mobile nuk preket.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  // Dawn përdor <details> brenda <header-menu> / <details-disclosure>
  const dropdowns = document.querySelectorAll('header-menu details, details-disclosure details, .header__inline-menu details');

  dropdowns.forEach((dd) => {
    const summary = dd.querySelector('summary');
    if (!summary) return;

    // MOS e hap me klikim në desktop (opsionale – komentoje këtë nëse do të lejosh edhe klikimin)
    summary.addEventListener('click', (e) => e.preventDefault());

    // Hape me hover
    dd.addEventListener('mouseenter', () => {
      // mbyll që janë të hapur
      dd.parentElement?.querySelectorAll('details[open]').forEach((s) => {
        if (s !== dd) s.removeAttribute('open');
      });
      dd.setAttribute('open', '');
    });

    dd.addEventListener('mouseleave', () => dd.removeAttribute('open'));
  });
});
